<template>
  <div>
    <p>
      Payments are made automatically and are calculated using our royalty
      rates. It also takes into account reductions from customers who have
      chosen to return unwanted goods for a refund. Payment rates for store
      operators can change as per our terms.
    </p>
    <p>
      <tml-anchor
        v-request-dashboard-permission="app.isTeemill ? 'view-royalties' : null"
        text="Click here"
        :href="
          hasDashboardPermission('view-royalties') ? '/sales-activity/' : '#'
        "
      />
      to view your sales activity report
    </p>
    <p>
      <tml-anchor text="Click here" href="/profit/" />
      to view our payment breakdown
    </p>
    <p>
      If you still feel you were paid too much or too little, please contact us
      using the form below.
    </p>
  </div>
</template>

<script>
export default {
  name: 'HelpWrongAmountForm',

  inject: ['app'],
};
</script>

<style lang="scss" scoped>
p {
  margin-top: 1em;
  margin-bottom: 1em;
}
</style>
